import { FormControlLabel, Switch, Theme } from "@mui/material";
import { SxProps } from "@mui/system";

//a simple wrapper for switch component

export type InputSwitchProps = {
  name: string;
  value: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  additionalSx?: SxProps<Theme>;
};

export const InputSwitch = (props: InputSwitchProps) => {
  const handleChange = (event: React.SyntheticEvent, checked: boolean) => {
    props.onChange(checked);
  };
  return (
    <FormControlLabel
      label={props.label}
      labelPlacement="end"
      onChange={handleChange}
      checked={props.value}
      name={props.name}
      control={<Switch color="secondary" />}
      sx={props.additionalSx}
    />
  );
};
